import React from "react";

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, colors } from "@mui/material";

type Props = React.ComponentProps<typeof IconButton>;

const MoreVertIconButton: React.FC<Props> = (props) => {
  return (
    <IconButton sx={{ padding: "2px" }} {...props}>
      <MoreVertIcon
        fontSize="small"
        sx={{ color: colors.grey }}
      />
    </IconButton>
  );
};

export default MoreVertIconButton;
